module.exports = __webpack_public_path__ + "img/default-avatar.a0fc9652.jpg";